import React, { Component } from 'react';
import styles from './styles.css';

export default class InputNumber extends Component {
  handleInputChange = e => {
    const nextVal = e.target.value;
    const {
      input: { onChange },
    } = this.props;
    if (
      !isNaN(nextVal) &&
      nextVal[0] !== '+' &&
      nextVal[0] !== '-' &&
      !/\s/g.test(nextVal) &&
      !/\./g.test(nextVal)
    ) {
      onChange(e, nextVal);
    }
  };

  render() {
    const {
      input,
      maxLength,
      placeholder,
      meta,
      customClassName,
      customErrorClassName,
      showTextError,
    } = this.props;
    const { touched, error } = meta;
    return (
      <div>
        <input
          {...input}
          type="tel"
          maxLength={maxLength}
          className={
            !touched
              ? `form-control ${customClassName}`
              : error
              ? `form-control ${customErrorClassName} ${!showTextError &&
                  `${styles['has-error']}`} ${customClassName}`
              : `form-control ${!showTextError &&
                  `${styles['has-success']}`} ${customClassName}`
          }
          placeholder={placeholder}
          onChange={this.handleInputChange}
        />
        <small className={styles.error}>{touched ? error : ''}</small>
      </div>
    );
  }
}
